import { Card } from '../../components/ui';
import AccionesEditarEliminar from './AccionesEditarEliminar';
import './Medico.css';

export default function TarjetaFranja({ franja }) {
  return (
    <Card>
      <div className="medico-row">
        <div>
          <strong>{franja.dia}</strong> · {franja.rango}
          <p className="medico-muted" style={{ margin: 0 }}>{franja.detalle}</p>
        </div>
        <AccionesEditarEliminar />
      </div>
    </Card>
  );
}